<template>
  <div>通讯录</div>
</template>

<script>
export default {
  name: "addAddressBookModal"
}
</script>

<style scoped>

</style>
